import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ConversionConfiguration } from 'src/app/model/conversion-configuration';

@Injectable({
  providedIn: 'root'
})
export class ConversionConfigurationService {
  private url:string;

  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  getList=()=> {
    return this.http.get(`${this.url}/ConversionConfigurationCredit/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  getListIntervals=()=> {
    return this.http.get(`${this.url}/ConversionConfigurationCredit/ListIntervals`)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  saveUpdate=(conversionConfig:ConversionConfiguration)=> {
    return this.http.post(`${this.url}/ConversionConfigurationCredit/SaveUpdate`, conversionConfig)
      .pipe(
        map((resp:any)=> resp)
      );
  }

  delete=(conversionConfig:ConversionConfiguration)=> {
    return this.http.post(`${this.url}/ConversionConfigurationCredit/Delete`, conversionConfig)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
